<section class="min-h-screen px-3 pb-8 pt-5 sm:px-5 lg:px-8">
  <div class="mx-auto max-w-[1600px]">

    <!-- Page header -->
    <div class="mb-5 flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-[#FFD4E0] text-[#D31148]">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 21s-7.5-4.35-10-8.35A6.2 6.2 0 0 1 12 4.5a6.2 6.2 0 0 1 10 8.15C19.5 16.65 12 21 12 21z" />
        </svg>
      </div>
      <div>
        <h1 class="text-xl font-bold text-gray-900">My Favourites</h1>
        <p class="text-sm text-gray-500">Posts, blogs and events you've saved</p>
      </div>
    </div>

    <!-- Filter tabs -->
    <div class="mb-5 overflow-x-auto rounded-xl border border-[#e8e8e8] bg-white px-3">
      <div class="flex min-w-max items-center gap-1 sm:gap-2">
        <button
          *ngFor="let tab of tabs"
          type="button"
          (click)="setFilter(tab.type)"
          class="flex items-center gap-2 border-b-2 py-3.5 px-3 text-sm font-medium transition-colors whitespace-nowrap"
          [ngClass]="activeFilter === tab.type
            ? 'border-[#D31148] text-[#D31148]'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'">
          <svg class="h-4 w-4 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path [attr.d]="tab.icon" />
          </svg>
          {{ tab.label }}
        </button>
      </div>
    </div>

    <!-- Not logged in state -->
    <div *ngIf="!isLoggedIn" class="flex flex-col items-center justify-center py-24 text-gray-400">
      <svg class="mb-4 h-16 w-16 opacity-30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M12 21s-7.5-4.35-10-8.35A6.2 6.2 0 0 1 12 4.5a6.2 6.2 0 0 1 10 8.15C19.5 16.65 12 21 12 21z" />
      </svg>
      <p class="mb-1 text-base font-semibold text-gray-600">Login to see your favourites</p>
      <p class="mb-4 text-sm">Save posts, blogs and events you love</p>
      <button (click)="goToLogin()"
        class="rounded-xl bg-[#D31148] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#b80e3d] transition-colors">
        Log In
      </button>
    </div>

    <!-- Content grid — "all" shows all three sections stacked -->
    <ng-container *ngIf="isLoggedIn">

      <!-- ALL: show all three types one after another -->
      <ng-container *ngIf="activeFilter === 'all'">

        <!-- Posts section -->
        <div class="mb-8">
          <div class="mb-3 flex items-center gap-2">
            <svg class="h-4 w-4 text-[#D31148]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <h2 class="text-sm font-bold text-gray-700 uppercase tracking-wide">Posts</h2>
          </div>
          <app-posts [embedded]="true" [favouritesMode]="true"></app-posts>
        </div>

        <!-- Blogs section -->
        <div class="mb-8">
          <div class="mb-3 flex items-center gap-2">
            <svg class="h-4 w-4 text-[#D31148]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
            <h2 class="text-sm font-bold text-gray-700 uppercase tracking-wide">Blogs</h2>
          </div>
          <app-blog [embedded]="true" [favouritesMode]="true"></app-blog>
        </div>

        <!-- Events section -->
        <div class="mb-8">
          <div class="mb-3 flex items-center gap-2">
            <svg class="h-4 w-4 text-[#D31148]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <h2 class="text-sm font-bold text-gray-700 uppercase tracking-wide">Events</h2>
          </div>
          <app-events [embedded]="true" [favouritesMode]="true"></app-events>
        </div>

      </ng-container>

      <!-- FILTERED: single type -->
      <app-posts *ngIf="activeFilter === 'post'" [embedded]="true" [favouritesMode]="true"></app-posts>
      <app-blog *ngIf="activeFilter === 'blog'" [embedded]="true" [favouritesMode]="true"></app-blog>
      <app-events *ngIf="activeFilter === 'event'" [embedded]="true" [favouritesMode]="true"></app-events>

    </ng-container>

  </div>
</section>

<app-scroll-to-top />
